function convertPrice(price) {
  return price && isFinite(price) ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
}

export default convertPrice;
